<template>
	<StepDetailsHeader :showDropdownMenu="false" v-bind="$attrs">
		<template #name-input>
			<div class="ml-2">{{ title }}</div>
		</template>
	</StepDetailsHeader>
</template>

<script>
import StepDetailsHeader from '../StepDetailsHeader.vue';

export default {
	name: 'TriggerEditorHeader',
	props: { title: { type: String } },
	components: { StepDetailsHeader },
};
</script>

<style lang="scss" scoped></style>
